export const exploreLinks: {
	testId: string;
	label: string;
	icon: JSX.Element;
	to: () => string;
}[] = [];
